export default {
  path: '',
  component: () => import(`@/component/admin-layout/index.vue`),
  children: [
    {
      path: '/admin/vuex-test',
      name: 'admin-vuex-test',
      component: () => import(`./index.vue`),
      meta: {
        entity_for_history_tag: {
          name: `vuex-test`,
        },
        entity_list_for_breadcrumb: [
          {name: `示例功能`},
          {name: `vuex-test`},
        ],
      },
    },
  ],
};
